var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1022_4067)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#E8EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 27.5001L25.6422 32.3212C25.7734 32.3868 25.839 32.4196 25.9078 32.4325C25.9687 32.4439 26.0313 32.4439 26.0922 32.4325C26.161 32.4196 26.2266 32.3868 26.3578 32.3212L36 27.5001M16 22.5001L25.6422 17.679C25.7734 17.6134 25.839 17.5806 25.9078 17.5677C25.9687 17.5562 26.0313 17.5562 26.0922 17.5677C26.161 17.5806 26.2266 17.6134 26.3578 17.679L36 22.5001L26.3578 27.3212C26.2266 27.3868 26.161 27.4196 26.0922 27.4325C26.0313 27.4439 25.9687 27.4439 25.9078 27.4325C25.839 27.4196 25.7734 27.3868 25.6422 27.3212L16 22.5001Z",
    stroke: "#2948A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1022_4067",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1022_4067"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1022_4067",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.55da06fb1770e7279aed6b44fa8ca82b.svg";
export { ForwardRef as ReactComponent };